import React from 'react';
import classNames from 'classnames';

import { Consulting } from '@layouts/Consulting';
import { DescriptionWithImage, QuoteWithButtons } from '@components';
import pairWithPuzzels from '@images/pair-with-puzzels.svg';
import calculator from '@static/images/figures/calculator.webp';
import { Header } from './components';
import { contacts } from '@store/ContactData';

import * as styles from './StaffAugmentation.module.scss';

export const StaffAugmentation: React.FC = () => {
	return (
		<>
			<Header />
			<DescriptionWithImage
				image={pairWithPuzzels}
				className="gray-bg pt-xl-0 pb-0"
				contentClassName={classNames(
					styles.content,
					'd-flex flex-column justify-content-center'
				)}
				imageBoxClassName={styles.imageBox}
			>
				<h2 className="font-600 mb-2">Is Staff Augmentation for me?</h2>
				<div className="font-size-sm line-height-sm">
					Staff Augmentation services are excellent for bridging some of your
					internal development team's skill gaps. Thanks to this model you can
					bring your team new competencies and experience. When you are looking
					for a senior developer who would lead your team or you are missing
					particular technology skills - Staff Augmentation could be the fastest
					option to increase your project.
				</div>
			</DescriptionWithImage>
			<QuoteWithButtons
				author={{
					name: contacts[0].name,
					position: contacts[0].position,
					email: contacts[0].email,
					linkedIn: contacts[0].linkedin,
					photo: contacts[0].image,
				}}
			>
				<h2 className="font-size-22 font-600 mb-2 pr-5">
					What kind of competencies are you looking for?
				</h2>
				<p className="font-size-sm line-height-sm">
					Contact me to discuss your requirements and build your dedicated IT
					team together with us.{' '}
				</p>
			</QuoteWithButtons>
			<DescriptionWithImage
				image={calculator}
				className="gray-bg"
				imageClassName={styles.calculatorImage}
				imageBoxClassName="justify-content-center justify-content-md-end"
				imageOnRight
			>
				<h2 className="font-600 mb-2">
					How do you calculate Staff Augmentation?
				</h2>
				<div className="font-size-sm line-height-sm">
					In this model, we can determine two methods of accounting. The first
					is the full-time rate, typically the best option for a long-term
					project. The second method is spent time, preferred for short-term
					projects.
				</div>
			</DescriptionWithImage>
			<Consulting />
		</>
	);
};
